import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { DirectivesModule } from '@app/shared/directives/directives.module';
import { DbmDropdownComponent } from '@app/shared/components/basic-components/dbm-dropdown/dbm-dropdown.component';

@NgModule({
    imports: [
        CommonModule,
        DirectivesModule
    ],
    declarations:[DbmDropdownComponent],
    exports: [
        DbmDropdownComponent, CommonModule
    ],
    entryComponents: [DbmDropdownComponent]
})
export class DbmDropdownModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/basic-components/dbm-dropdown/dbm-dropdown.module.ts